// extracted by mini-css-extract-plugin
export default {"colorContainer":"color_colorContainer__rRUGw","colorOption":"color_colorOption__hmj+E","colorWrapper":"color_colorWrapper__FNVdZ","sketchPicker":"color_sketchPicker__SS+3N"};